import { getOrThrow } from '@tectonics/utils/getters';
import type { PendingIncomingPayment } from '@tectonics/prs/incoming-payment';

export type Gateway = {
  readonly voucher_code: string,
  readonly voucher_url: string,
  readonly nequi_qr_code: string,
  readonly acquirer_expiration_datetime: string,
  readonly pix_expiration_datetime: string | null,
  readonly ussd_code: string,
  readonly bank_code: string,
  readonly payment_code: string,
};

export const getSafeGateway = (payment: PendingIncomingPayment): Gateway => getOrThrow(
  payment.gateway,
  'GetGateway: gateway is not available in incoming payment',
);
